import Mousetrap from 'mousetrap';

const origStopCallback = Mousetrap.prototype.stopCallback;
Mousetrap.prototype.stopCallback = function stopCallback(e, element, combo) {
  return origStopCallback.call(this, e, element, combo) && combo.indexOf('esc') === -1;
};

function shortcutsMixin(Base, shortcuts = []) {
  return class extends Base {
    componentDidMount(...args) {
      if (typeof super.componentDidMount === 'function') super.componentDidMount(...args);
      shortcuts.forEach((shortcut) => {
        Mousetrap.bind(shortcut.key, (e) => { this[shortcut.func](e); });
      });
    }
    componentWillUnmount(...args) {
      if (typeof super.componentWillUnmount === 'function') super.componentWillUnmount(...args);
      shortcuts.forEach((shortcut) => {
        Mousetrap.unbind(shortcut.key);
      });
    }
  };
}

export default shortcutsMixin;



// WEBPACK FOOTER //
// ./client/app/shared/mixins/shortcuts.js